<template>
     <div class="quota-exceeded" v-if="mailbox_quota.storage_virtual_percentage >= 90 && warning_visible === true">
        <ActionButton
            icon='fas fa-times-circle'
            class="close"
            @click="onWarningDismiss"
        />
        <i class="fas fa-exclamation-circle"></i>

        <template v-if="mailbox_quota.storage_percentage >= 99">

            <strong>Sem espaço de armazenamento</strong>
            <span>
                Está a usar mais espaço do que a sua conta permite.<span class="strong"> Não é possível receber ou enviar mensagens</span> quando a conta está neste estado.
            </span>
        </template>


        <template v-else-if="mailbox_quota.storage_virtual_percentage >= 99">
            <strong>Sem espaço de armazenamento</strong>
            <span>
                Está a usar mais espaço do que a sua conta permite. Se a conta permanecer neste estado, <span class="strong"> deixará de ser possível receber ou enviar mensagens.</span>
            </span>
        </template>

        <template v-else-if="mailbox_quota.storage_virtual_percentage >= 90">
            <strong>Armazenamento quase cheio</strong>
            <span>
                Está a usar {{ mailbox_quota.storage_virtual_percentage }}% do espaço disponível.
            </span>
        </template>


        <span v-if="AccountControllerSingleton.account.premium.allowed === true">
            Liberte espaço ou
            <LinkButton
            :link="SAPOMailConfigSingleton.server.external_links.premium"
            text="adira ao Premium"
            target="_blank"
            :gtm="{
                module : 'messages',
                feature: `overquota_warning`,
                block  : `pre_content`,
                action : `premium_subscribe`
            }"
        />
            para obter 65GB.
        </span>

        <span v-else>
            Use a opção "Limpeza de E-mail", nas Definições, para apagar mensagens.
        </span>
     </div>
</template>

<script setup>
    import {reactive, ref}            from 'vue';
    import MailboxController          from '@/js/Mailboxes/MailboxController.js';
    import AccountControllerSingleton from '@/js/Webmail/AccountController.js';
    import LinkButton                 from '@/vue/Elements/Buttons/LinkButton.vue';
    import ActionButton               from '@/vue/Elements/Buttons/ActionButton.vue';
    import StateConsumerSingleton     from '@/js/Shared/State/StateConsumer';
    import SAPOMailConfigSingleton    from '@/SAPOMailConfig';

    const mailbox_quota   = reactive(MailboxController.quota);
    const warning_visible = ref(StateConsumerSingleton.peek('quota_warning', true));

    const onWarningDismiss = () => {
        warning_visible.value = false;
        StateConsumerSingleton.set('quota_warning', false);
    }
</script>